import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Select, SelectType } from '@components/atoms/Select';

export interface ProductAttributesSelectorProps {
    availableAttributes: {
        uuid?: string;
        label?: string;
        values?: { uuid?: string; value?: string }[];
    }[];
    selected: { attributeUuid?: string; valueUuid?: string }[];
    onChange: (valueUuid: string, attributeUuid: string) => void;
}

export const ProductAttributesSelector: FC<ProductAttributesSelectorProps> = ({ availableAttributes, selected, onChange }) => {
    const { t } = useTranslation();

    const translations = {
        select: t('product-attributes-selector-component.select-option'),
    };

    useEffect(() => {
        availableAttributes?.forEach((attribute) => {
            const values = attribute.values || [];
            const isAlreadySelected = selected.some((item) => item.attributeUuid === attribute.uuid);
            if (values.length === 1 && !isAlreadySelected) {
                onChange(values[0].uuid || '', attribute.uuid || '');
            }
        });
    }, [availableAttributes, selected, onChange]);

    return (
        <>
            {availableAttributes?.map((attribute) => {
                const values = attribute.values || [];
                const selectedValueUuid = selected.find((item) => item.attributeUuid === attribute.uuid)?.valueUuid;
                
                return (
                    <div key={attribute.uuid || ''} className="d-flex align-items-center gap-2 mb-3 mb-md-4">
                        <Typography tagVariant={TypographyTagVariants.span} fontWeight="800" fontSize="16">
                            {`${attribute.label}: `}
                        </Typography>

                        {values.length === 1 ? (
                            <Typography tagVariant={TypographyTagVariants.span} fontWeight="400" fontSize="16">
                                {values[0].value}
                            </Typography>
                        ) : (
                            <Select
                                type={SelectType.variant1}
                                options={[{ text: translations.select, value: '' }, ...values.map((item) => ({ value: item.uuid || '', text: item.value || '' }))]}
                                value={selectedValueUuid || ''}
                                onChange={(valueUuid) => onChange(valueUuid, attribute.uuid || '')}
                            />
                        )}
                    </div>
                );
            })}
        </>
    );
};
